import { Component, Input } from '@angular/core';

import { IVideoReviewAlertEntry, VideoReviewFindingType } from './VideoReviewTypes';

import { VideoReviewEntryBase } from './VideoReviewEntryBase.Directive';

@Component({
	selector: 'video-review-alert-entry',
	host: { '[class]': 'styles.alertEntryRoot' },
	template: `
		<div [ngClass]="styles.entry">
			<div [ngClass]="styles.entryIconWrapper">
				<span [ngClass]="styles.icon" class="vb-icon vb-icon-center vb-icon-alert"></span>
			</div>
			<div [ngClass]="styles.entryDetails">
				<div [ngClass]="styles.entryHeading">
					{{ (complianceAlert.findingType === VideoReviewFindingType.SensitiveData ? 'Violation_SensitiveData' : 'Violation_Keyword') | translate : { '0' : complianceAlert.finding } }}
					<div [ngClass]="styles.entrySubHeading">
						{{ 'ApprovalProcess_AI_ContentAnalysis_ApproverStep' | translate : {'0': complianceAlert.stepName } }}
					</div>
				</div>
				<div *ngFor="let occurrence of complianceAlert.occurrences" [ngClass]="styles.entryContent">
					<button type="button" class="btn btn-transparent" [ngClass]="styles.entryBtn" (click)="onEntryClick(occurrence.segment)">
						&#64;{{ occurrence.segment * SecondMs | vbTimespan : showHoursInTimestamp : true }}&nbsp;&nbsp;-&nbsp;
					</button>
					<span [innerHTML]="occurrence.segmentText"></span>
				</div>
				<div [ngClass]="styles.entryFooter">
					<div *ngIf="!isReadOnlyMode" [ngClass]="styles.entryFooterBtns">
						<button type="button" class="btn btn-transparent" [ngClass]="styles.entryBtn" (click)="onReplyClick()">
							<span class="vb-icon vb-icon-center vb-icon-return"></span>&nbsp;&nbsp;
							{{ 'Reply' | translate }}
						</button>
					</div>
					<video-review-reply-input
						*ngIf="showReplyInput && !isReadOnlyMode"
						[ngClass]="styles.entryReplyInput"
						(replySubmitted)="onReplySubmitted($event)"
						(hideReplyInput)="onHideReplyInput($event)">
					</video-review-reply-input>
					<video-review-reply-entry
						*ngFor="let reply of complianceAlert.replies"
						[isReadOnlyMode]="isReadOnlyMode"
						[reply]="reply"
						[currentUserId]="currentUserId"
						(deleteClicked)="onDeleteReplyClicked($event)">
					</video-review-reply-entry>
				</div>
			</div>
		</div>
	`
})
export class VideoReviewAlertEntryComponent extends VideoReviewEntryBase {
	@Input({ required: true }) public complianceAlert: IVideoReviewAlertEntry;

	public readonly VideoReviewFindingType = VideoReviewFindingType;

	public onReplySubmitted(reply: string): void {
		this.VideoReviewService.addAlertReply(this.videoId, this.complianceAlert.stepId, this.complianceAlert.id, reply);
	}

	public onDeleteReplyClicked(replyId: string): void {
		this.VideoReviewService.deleteAlertReply(this.videoId, this.complianceAlert.stepId, this.complianceAlert.id, replyId);
	}

}
